import React, { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  'https://bopvbykhekvrayihgfqm.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJvcHZieWtoZWt2cmF5aWhnZnFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1ODcyOTgsImV4cCI6MjA2MDE2MzI5OH0.PaJUSFBblBC7b74NrvDMNMZNMiLczHItdfJbMWCe5Lw'
);

export default function NewbiesPage() {
  const [characters, setCharacters] = useState([]);

  useEffect(() => {
    const fetchRecentCharacters = async () => {
      const { data, error } = await supabase
        .from('characters')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(100);

      if (!error) setCharacters(data);
    };

    fetchRecentCharacters();
  }, []);

  return (
    <div style={{ padding: '2rem' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '2rem' }}>🌟 Meet the New Guys</h1>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: '1.5rem' }}>
        {characters.map((char) => (
          <div key={char.id} style={{ textAlign: 'center' }}>
            <img src={char.image} alt={char.name} style={{ width: '100%', borderRadius: '12px' }} />
            <p style={{ marginTop: '0.5rem', fontWeight: 'bold' }}>{char.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}